module.exports = __webpack_public_path__ + "static/media/iFuture.a3dc9768.png";